export const reasons = [
  'authModal.reasonsRapidOrder',
  'authModal.reasonsTrackOrder',
  'authModal.reasonsUpdateData',
  'authModal.accessOrderLiveChanges',
] as const;
